import React, { useEffect, useRef } from 'react';
import { find, get } from 'lodash';

import { getCompletionPercentage } from 'app/oms/components/utils/omsUtils';
import { getFulfillmentStatuses } from '@broadleaf/admin-components/dist/oms/utils/OrderStatusUtils';

const AuroraFulfillmentCardStatusIndicator = ({
  orderMetadata,
  fulfillment
}) => {
  const { status, attributes } = fulfillment;
  const fulfillmentStatuses = getFulfillmentStatuses(orderMetadata);
  const { label, color } = find(fulfillmentStatuses, {
    value: status
  }) || { label: status, color: 'gray' };
  const completionPercentage = getCompletionPercentage(status);
  const barRef = useRef<HTMLDivElement>(null);
  const transactionMessages = get(attributes, 'TXN_MESSAGES', '');

  useEffect(() => {
    if (barRef.current) {
      // csp header workaround
      barRef.current.style.width = completionPercentage;
    }
  }, [completionPercentage]);

  return (
    <div className="tw-relative tw-w-full tw-py-1">
      <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between">
        <div>
          <span
            className={`tw-inline-block tw-rounded-full tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-uppercase tw-text-${color}-600 tw-bg-${color}-200`}
          >
            {label}
          </span>
          <span className="tw-ml-2 tw-text-xs tw-font-semibold tw-uppercase tw-text-gray-600">
            {transactionMessages}
          </span>
        </div>
      </div>
      <div
        className={`tw-mb-4 tw-flex tw-h-2 tw-overflow-hidden tw-rounded tw-text-xs tw-bg-${color}-200`}
      >
        <div
          ref={barRef}
          className={`tw-flex tw-flex-col tw-justify-center tw-whitespace-nowrap tw-text-center tw-text-white tw-shadow-none tw-bg-${color}-500`}
        />
      </div>
    </div>
  );
};

export default AuroraFulfillmentCardStatusIndicator;
